import { render } from "./RecommendedForYou.vue?vue&type=template&id=d5aa3750&ts=true"
import script from "./RecommendedForYou.vue?vue&type=script&lang=ts"
export * from "./RecommendedForYou.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__